import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card w-100 h-100 d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column align-items-start"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold" }, "Error", -1 /* HOISTED */)
const _hoisted_4 = { class: "font-size-xl mb-1" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" There was problem while loading the referral. Please try again. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" There was problem while generating the referral form. Please try again. ")
const _hoisted_7 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list fa-7x text-primary animated flash infinite slow mb-2" }, null, -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-xl" }, "Loading Referral Form...", -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "d-flex flex-column align-items-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x text-primary animated flash infinite slow mb-2" }, null, -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-xl text-center" }, "Saving Referral...", -1 /* HOISTED */)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  id: "HosPal_New_Referral"
}
const _hoisted_16 = { class: "convert-header mb-1" }
const _hoisted_17 = { class: "card mx-2 mb-4" }
const _hoisted_18 = { class: "card-body form-content p-3 mx-lg-6" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_24 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = {
  key: 0,
  class: "d-flex justify-content-center form-footer gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HosPalReferralInformation = _resolveComponent("HosPalReferralInformation")!
  const _component_PatientTags = _resolveComponent("PatientTags")!
  const _component_DemographicsInformation = _resolveComponent("DemographicsInformation")!
  const _component_PayorInformation = _resolveComponent("PayorInformation")!
  const _component_AdmissionInformation = _resolveComponent("AdmissionInformation")!
  const _component_PatientAuthorizedContacts = _resolveComponent("PatientAuthorizedContacts")!
  const _component_PatientGoals = _resolveComponent("PatientGoals")!
  const _component_ClinicianInformation = _resolveComponent("ClinicianInformation")!
  const _component_PatientHealthHistory = _resolveComponent("PatientHealthHistory")!
  const _component_ReferralDocuments = _resolveComponent("ReferralDocuments")!
  const _component_ReferralReadiness = _resolveComponent("ReferralReadiness")!
  const _component_PatientPreadmissionNotes = _resolveComponent("PatientPreadmissionNotes")!
  const _component_PageLayout = _resolveComponent("PageLayout")!

  return (_openBlock(), _createBlock(_component_PageLayout, {
    "has-buttons": true,
    "has-title": false,
    "content-class": "p-0",
    "has-page-scroll": false
  }, {
    content: _withCtx(() => [
      (_ctx.isLoadError || _ctx.isFormLoading || _ctx.isSaveInProgress)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            (_ctx.isLoadError && !_ctx.isFormLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("p", _hoisted_4, [
                    (_ctx.referralId)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_5
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_6
                        ], 64 /* STABLE_FRAGMENT */))
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadReferral()))
                  }, "Try Again")
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.isLoadError && _ctx.isFormLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
              : _createCommentVNode("v-if", true),
            (_ctx.isSaveInProgress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.isLoadError && !_ctx.isFormLoading && !_ctx.isSaveInProgress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(` ${_ctx.applicationId == _ctx.hospiceApplicationId ? "Hospice" : "Pallative Care"} Referral`), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_HosPalReferralInformation, { "provider-id": _ctx.providerId }, null, 8 /* PROPS */, ["provider-id"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_DemographicsInformation, {
                    referral: _ctx.referral,
                    "is-patient": false,
                    "provider-id": _ctx.providerId,
                    "is-his-section": _ctx.isHisSection,
                    "is-refer": _ctx.isRefer,
                    "is-create": _ctx.isCreate
                  }, {
                    tags: _withCtx(() => [
                      _createVNode(_component_PatientTags, {
                        patient: _ctx.referral,
                        "provider-id": _ctx.providerId
                      }, null, 8 /* PROPS */, ["patient", "provider-id"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["referral", "provider-id", "is-his-section", "is-refer", "is-create"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_PayorInformation, {
                    "provider-id": _ctx.providerId,
                    "is-his-section": _ctx.isHisSection
                  }, null, 8 /* PROPS */, ["provider-id", "is-his-section"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.referral.application == _ctx.hospiceApplicationId)
                    ? (_openBlock(), _createBlock(_component_AdmissionInformation, {
                        key: 0,
                        "is-read-only": false
                      }))
                    : _createCommentVNode("v-if", true)
                ]),
                (!_ctx.loadReferAuthorizedContact)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_PatientAuthorizedContacts, {
                        "patient-id": _ctx.referralId,
                        application: _ctx.referral.application,
                        "account-id": _ctx.referral.accountId,
                        "patient-primary-address": _ctx.referral.primaryAddress,
                        "referred-contact": _ctx.referringAuthorizedContact
                      }, null, 8 /* PROPS */, ["patient-id", "application", "account-id", "patient-primary-address", "referred-contact"])
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.referral.application == _ctx.palliativeApplicationId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_component_PatientGoals, { referral: _ctx.referral }, null, 8 /* PROPS */, ["referral"])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_ClinicianInformation, {
                    "provider-id": _ctx.providerId,
                    "referring-patient-diagnosis": _ctx.referringPatientDiagnosis
                  }, null, 8 /* PROPS */, ["provider-id", "referring-patient-diagnosis"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.referral.application == _ctx.palliativeApplicationId)
                    ? (_openBlock(), _createBlock(_component_PatientHealthHistory, {
                        key: 0,
                        patient: _ctx.referral
                      }, null, 8 /* PROPS */, ["patient"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (_ctx.referral.id && _ctx.canShowReferralDocuments)
                    ? (_openBlock(), _createBlock(_component_ReferralDocuments, {
                        key: 0,
                        referral: _ctx.referral,
                        "provider-id": _ctx.providerId
                      }, null, 8 /* PROPS */, ["referral", "provider-id"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_ReferralReadiness, { referral: _ctx.referral }, null, 8 /* PROPS */, ["referral"])
                ]),
                _createVNode(_component_PatientPreadmissionNotes, {
                  ref: "notesSection",
                  application: _ctx.applicationId,
                  "referral-id": _ctx.referralId,
                  "is-referral": true,
                  referral: _ctx.referral
                }, null, 8 /* PROPS */, ["application", "referral-id", "referral"])
              ])
            ]),
            (!_ctx.isLoadError && !_ctx.isFormLoading && !_ctx.isSaveInProgress)
              ? (_openBlock(), _createElementBlock("footer", _hoisted_29, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary me-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleConvertToPending(_ctx.referral)))
                  }, " Convert to Pending "),
                  (!_ctx.isCreate)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary me-2",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.update()))
                      }, " Save Referral "))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-primary me-2",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.create()))
                      }, " Create Referral ")),
                  _createElementVNode("button", {
                    class: "btn btn-outline-primary me-2",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToReferralList()))
                  }, " View Referral List "),
                  _createElementVNode("button", {
                    class: "btn btn-outline-primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToReferralList(true)))
                  }, "Cancel")
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}